import { useContext } from "react";
import ColumnResizeHandleContext from "./ColumnResizeHandleContext";

// Displays an overlay when resizing a column so we don't
// trigger any hovers on elements while dragging
export default function DataTableResizedColumnOverlay() {
  const { resizedColumnId } = useContext(ColumnResizeHandleContext);

  return (
    <>
      {resizedColumnId && (
        <div className="w-dvw h-dvh z-50 fixed left-0 top-0" />
      )}
    </>
  );
}
